(function () {
  function initToxicWasteSlider(section) {
    if (!section || section.dataset.sliderInitialized === 'true') {
      return;
    }

    const slider = section.querySelector('.toxic-waste-cards__grid');
    const slides = Array.from(
      section.querySelectorAll('.toxic-waste-cards__card')
    );
    const dots = Array.from(
      section.querySelectorAll('.toxic-waste-cards__dot')
    );

    if (!slider || slides.length < 2 || dots.length !== slides.length) {
      return;
    }

    section.dataset.sliderInitialized = 'true';

    function isMobile() {
      return window.matchMedia('(max-width: 767px)').matches;
    }

    function setActiveDot(index) {
      dots.forEach(function (dot, dotIndex) {
        const isActive = dotIndex === index;
        dot.classList.toggle('is-active', isActive);
        dot.setAttribute('aria-current', isActive ? 'true' : 'false');
      });
    }

    function getActiveIndex() {
      if (!slider.clientWidth) {
        return 0;
      }

      return Math.max(
        0,
        Math.min(
          slides.length - 1,
          Math.round(slider.scrollLeft / slider.clientWidth)
        )
      );
    }

    dots.forEach(function (dot, index) {
      dot.addEventListener('click', function () {
        if (!isMobile()) {
          return;
        }

        slider.scrollTo({
          left: slider.clientWidth * index,
          behavior: 'smooth'
        });
        setActiveDot(index);
      });
    });

    let scrollTimer;

    slider.addEventListener(
      'scroll',
      function () {
        if (!isMobile()) {
          return;
        }

        clearTimeout(scrollTimer);
        scrollTimer = setTimeout(function () {
          setActiveDot(getActiveIndex());
        }, 80);
      },
      { passive: true }
    );

    window.addEventListener('resize', function () {
      if (!isMobile()) {
        slider.scrollLeft = 0;
        setActiveDot(0);
      }
    });
  }

  function initAllToxicWasteSliders(root) {
    const scope = root || document;

    if (scope.matches && scope.matches('.toxic-waste-cards')) {
      initToxicWasteSlider(scope);
    }

    scope
      .querySelectorAll('.toxic-waste-cards')
      .forEach(initToxicWasteSlider);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAllToxicWasteSliders(document);
    });
  } else {
    initAllToxicWasteSliders(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAllToxicWasteSliders(event.target);
  });
})();
